import { TaskPhase, TaskStatus } from '#/protobuf/task_pb';
import { STATUS_DESCRIPTION, taskIsErrored, taskIsCompleted } from '#/models/jobs/task';

export { STATUS_DESCRIPTION } from '#/models/jobs/task';

// creates a list of all nonnull root tasks in a JobTask bundle
export function iterableJobTasks(rootTasks) {
  const all = [];
  if (rootTasks.copyTask !== undefined) all.push(rootTasks.copyTask);
  if (rootTasks.verifyTask !== undefined) all.push(rootTasks.verifyTask);
  if (rootTasks.uploadTask !== undefined) all.push(rootTasks.uploadTask);
  if (rootTasks.downloadTask !== undefined) all.push(rootTasks.downloadTask);
  if (rootTasks.transcodeTask !== undefined) all.push(rootTasks.transcodeTask);
  if (rootTasks.thumbnailTask !== undefined) all.push(rootTasks.thumbnailTask);
  if (rootTasks.metadataTask !== undefined) all.push(rootTasks.metadataTask);
  if (rootTasks.compareTask !== undefined) all.push(rootTasks.compareTask);
  if (rootTasks.reportTask !== undefined) all.push(rootTasks.reportTask);
  if (rootTasks.indexTask !== undefined) all.push(rootTasks.indexTask);
  return all;
}

// array of all defined tasks on a snapshot
export function snapshotTasks(snapshot) {
  return iterableJobTasks(snapshot.rootTasks);
}

// iterate all tasks to determine if error exists
export function snapshotIsErrored(snapshot) {
  return snapshotTasks(snapshot).some((task) => taskIsErrored(task));
}

export function snapshotIsCompleted(snapshot) {
  return snapshotTasks(snapshot).some((task) => taskIsCompleted(task));
}

// aggregate status description across all tasks for a snapshot
export function snapshotStatusDescription(snapshot) {
  // console.error('==SNAPSHOT==',snapshot);
  // if ANY task is errored show "errored"
  if (snapshotIsErrored(snapshot)) {
    // short circuit out with "Errored" if applicable
    return STATUS_DESCRIPTION.ERRORED;
  }

  if (snapshotIsCompleted(snapshot)) {
    return STATUS_DESCRIPTION.DONE;
  }
  // else if ANY task is cancelled show "canceled"
  // else if ANY task is working show "working"
  // else if ANY task is paused show "paused"
  // else if ANY task is waiting show "waiting"
  // else if ALL tasks are done show "done"
  // else "unknown" - there is an undefined phase or a task with PHASE_NONE
  let canceled = 0;
  let done = 0;
  let working = 0;
  let paused = 0;
  let waiting = 0;
  let unknown = 0;
  let taskCount = 0;
  snapshotTasks(snapshot).forEach((task) => {
    taskCount += 1;
    switch (task.info.taskPhase) {
      case TaskPhase.PHASE_WAITING:
        waiting += 1;
        break;
      case TaskPhase.PHASE_PAUSED:
        paused += 1;
        break;
      case TaskPhase.PHASE_WORKING:
        working += 1;
        break;
      case TaskPhase.PHASE_CANCELED:
        canceled += 1;
        break;
      case TaskPhase.PHASE_DONE:
        done += 1;
        break;
      default:
        unknown += 1;
    }
  });
  if (canceled > 0) return STATUS_DESCRIPTION.CANCELED;
  if (working > 0) return STATUS_DESCRIPTION.WORKING;
  if (paused > 0) return STATUS_DESCRIPTION.PAUSED;
  if (waiting > 0) return STATUS_DESCRIPTION.WAITING;
  if (done === taskCount) return STATUS_DESCRIPTION.DONE;
  console.warn(`${unknown} tasks with unknown phases`);
  return STATUS_DESCRIPTION.UNKNOWN;
}
